"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateOpenURLSAP = exports.SAPPassportHeaderDefault = exports.SAPPassportFormDefault = exports.SAPPassportDefault = exports.NOT_SET = void 0;
var _uuid = require("uuid");
var NOT_SET = exports.NOT_SET = "NOT_SET";
var SAPPassportHeaderDefault = exports.SAPPassportHeaderDefault = function SAPPassportHeaderDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    authCode: "",
    clientID: "",
    clientSecret: "",
    tenantURL: "",
    authorizationURL: ""
  };
};
var SAPPassportDefault = exports.SAPPassportDefault = function SAPPassportDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    isConnected: false,
    clientID: "",
    clientSecret: "",
    tenantURL: "",
    authorizationURL: ""
  };
};
var SAPPassportFormDefault = exports.SAPPassportFormDefault = function SAPPassportFormDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    isConnected: false,
    clientID: "",
    clientSecret: "",
    tenantURL: "",
    authorizationURL: "",
    authCode: ""
  };
};
var generateOpenURLSAP = exports.generateOpenURLSAP = function generateOpenURLSAP(passport, currentURL) {
  return "".concat(passport.authorizationURL) + "?client_id=".concat(encodeURIComponent(passport.clientID)) + "&response_type=code" + "&redirect_uri=https://integrations.userful.com/oauth2/sap/sac" + "&state=".concat(currentURL);
};